export default __webpack_public_path__ + "static/giftt-57a5a27dffc68bacbbbede705b9fe6e0.svg";